var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdleVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-10 h-10",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.92 6.62A3 3 0 0 0 16 5H8a3 3 0 0 0-2.92 2.62L4.07 11H4a3 3 0 0 0 0 6h1a3 3 0 0 0 6 0h2a3 3 0 0 0 6 0h1a3 3 0 0 0 0-6h-.07ZM6.85 7.73A1 1 0 0 1 8 7h8a1 1 0 0 1 1 .73L18.29 11H5.71ZM7 17a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm10 0a1 1 0 1 1 1-1 1 1 0 0 1-1 1Zm4-3h-1.18a3 3 0 0 0-5.64 0h-2.36a3 3 0 0 0-5.64 0H3a1 1 0 0 1 0-2h18a1 1 0 0 1 0 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdleVehicle);
export default __webpack_public_path__ + "static/media/idle-vehicle.0a1e7fe2139fb5d6b38856ccd64f8b75.svg";
export { ForwardRef as ReactComponent };